import { render, staticRenderFns } from "./userCreateModal.vue?vue&type=template&id=4dc67ad1&"
import script from "./userCreateModal.vue?vue&type=script&lang=ts&"
export * from "./userCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports